import React from 'react'

import SectionContainer from '@/Section/Container'

import MediaWithTag from '@/MediaWithTag'
import Heading from '@/UI/Heading'
import Divider from '@/UI/Divider'

import SubTitle from './Subtitle'

import {
  ScaleX,
  FadeIn
} from 'animations'

import {
  StyledHero,
  StyledHeroContainer,
  StyledHeroSubtitleWrapper
} from './styles'


const Hero = ({
  title,
  subtitle,
  asTitle = true,
  mediaWithTag,
  showNews,
  news = null
}) => {
  const isFullScreen = !!mediaWithTag && mediaWithTag.layout === 'cover'

  return (
    <StyledHero
      fullScreen={isFullScreen}
    >

      <StyledHeroContainer>
        <SectionContainer
          css={{ paddingY: 0 }}
          variants={FadeIn({ staggerChildren: 0.2 })}
        >
          {
            title &&
            <Heading

              css={{ maxWidth: 900 }}
              className={ isFullScreen ? 'TitleInCover' : ''}
              as={asTitle ? 'h1' : 'h2'}
              dangerouslySetInnerHTML={{ __html: title }}
            />
          }
          {
            (subtitle || showNews) &&
            <StyledHeroSubtitleWrapper>
              <Divider
                variants={ScaleX({ opts: { delay: 0.7 } })}
              />
              <SubTitle content={subtitle} withBackground={isFullScreen} showNews={showNews} news={news} />
            </StyledHeroSubtitleWrapper>
          }

          {
            mediaWithTag &&
            mediaWithTag.layout !== 'cover' &&
            <MediaWithTag title={title} {...mediaWithTag} />
          }
        </SectionContainer>
      </StyledHeroContainer>
      {
        mediaWithTag &&
        mediaWithTag.layout === 'cover' &&
        <MediaWithTag title={title} {...mediaWithTag} />
      }
    </StyledHero>
  )
}

export default Hero
